<ng-container *ngIf="!multiple; else withMultipleProducts">
  <ng-container
    *ngTemplateOutlet="
      summaryTemplate;
      context: {
        ipBoard: ipBoard,
        project: project,
        baseProject: baseProject,
        canShowAdminSections: true,
        safari: safari,
        client: client
      }
    "
  ></ng-container>
</ng-container>

<ng-template #withMultipleProducts>
  <mat-card class="top-card mat-elevation-z0 multiple-products-summary-card">
    <ng-container
      *ngTemplateOutlet="
        summaryTemplate;
        context: {
          ipBoard: ipBoard,
          project: project,
          baseProject: baseProject,
          canShowAdminSections: index === 0,
          safari: safari,
          client: client
        }
      "
    ></ng-container>
  </mat-card>
</ng-template>

<ng-template
  #summaryTemplate
  let-ipBoard="ipBoard"
  let-baseProject="baseProject"
  let-canShowAdminSections="canShowAdminSections"
  let-safari="safari"
  let-client="client"
>
  <div class="summary-card-container">
    <div class="summary-card-header">Configuratie</div>
    <mat-card class="top-card summary-card mat-elevation-z0 black-border-color">
      <div class="small-upper-space d-flex">
        <div class="configuration-container">
          <div class="strong f-s-larger">
            <ng-container
              *ngIf="ipBoard.boardPart.sign != null; else typeNoSign"
            >
              {{
                ipBoard.boardPart.sign.type?.value ===
                SIGN_TYPE_CHOICES.STICKER.value
                  ? 'Kleefbord'
                  : 'IP bord'
              }}
            </ng-container>
            <ng-template #typeNoSign>
              {{
                ipBoard.boardPart.otherIPBoardPartType?.ordinal ===
                IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
                  ? 'Kleefbord'
                  : 'IP bord'
              }}
            </ng-template>
          </div>
          <div>
            {{
              project.collaborative
                ? 'Gezamenlijke opdracht'
                : ipBoard.boardPart.sign != null
                ? 'Voorraadbord'
                : 'Aangepast bord'
            }}
          </div>
          <div
            [ngClass]="
              ipBoard.boardPart.otherIPBoardPartType?.ordinal !==
              IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
                ? 'upper-space'
                : ''
            "
          >
            <div *ngIf="ipBoard.boardPart.sign != null">
              <span>
                {{
                  ipBoard.boardPart.sign.type?.value ===
                    SIGN_TYPE_CHOICES.STICKER.value
                    | formatIPBoardDimensions
                      : ipBoard.boardPart.sign.signMeasurements?.height
                      : ipBoard.boardPart.sign.signMeasurements?.width
                      : ipBoard.boardPart.sign.shape?.value ===
                          SIGN_SHAPE_TYPE_CHOICES.UPRIGHT.value
                      : null
                      : null
                      : false
                }}
                -
              </span>
              <span>{{ ipBoard.boardPart.sign?.title }} - </span>
              <span>{{ ipBoard.boardPart.sign?.phoneNumber }}</span>
            </div>
            <div *ngIf="ipBoard.boardPart.sign == null">
              <span>
                {{
                  ipBoard.boardPart.otherIPBoardPartType?.ordinal ===
                    IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
                    | formatIPBoardDimensions
                      : null
                      : null
                      : false
                      : ipBoard.boardPart.otherHeight
                      : ipBoard.boardPart.otherWidth
                      : false
                }}</span
              >
            </div>
          </div>

          <div
            *ngIf="
              ipBoard.boardPart.boardType != null ||
              ipBoard.boardPart.placementType != null
            "
          >
            {{
              ipBoard.boardPart.boardType?.label
                | joiner
                  : ' - '
                  : (ipBoard.boardPart.placementType?.ordinal
                      | ipBoardPlacementTypeOrAlternative
                        : ipBoard.boardPart.placementType?.label
                        : ipBoard.boardPart.alternativePlacementType
                        : 'Andere plaatsingsmethode')
            }}
          </div>
        </div>
        <div class="configuration-preview">
          <div *ngIf="boardTypePreviewUrl != null">
            <img class="board-type-preview" src="{{ boardTypePreviewUrl }}" />
          </div>
          <div
            *ngIf="placementTypePreviewUrl != null"
            [ngClass]="boardTypePreviewUrl != null ? 'left-space' : ''"
          >
            <img width="185" height="170" src="{{ placementTypePreviewUrl }}" />
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <ng-container
    *ngIf="!client && canShowAdminSections && baseProject.putOnHold != null"
  >
    <div class="admin-section-header">
      <div
        [class.collapsed]="onHoldSectionCollapsed"
        class="d-flex"
        (click)="onHoldSectionCollapsed = !onHoldSectionCollapsed"
      >
        <div>On hold</div>
        <div class="admin-section-arrow">
          <div>
            <button mat-icon-button>
              <mat-icon class="admin-section-arrow-icon"
                >arrow_drop_up</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
    </div>
    <div [collapse]="onHoldSectionCollapsed" [isAnimated]="!safari">
      <div class="summary-card-container summary-card-top-margin">
        <div class="summary-card-header">On hold</div>
        <mat-card
          class="top-card summary-card mat-elevation-z0 black-border-color"
        >
          <div class="upper-space less-mat-form-field-bottom-padding">
            <textarea-input
              [subtitle]="'Reden waarom on hold'"
              [placeholder]="''"
              [initContent]="baseProject.onHoldReason"
              [sensitive]="true"
              (answer)="onHoldReasonChanged($event)"
            >
            </textarea-input>
            <div
              *ngIf="baseProject.putOnHold != null"
              class="registered-action-display-container"
            >
              <div>
                <i>On hold geplaatst door</i>
              </div>
              <div>
                <i>{{
                  baseProject.putOnHold.by?.firstName
                    | personName : baseProject.putOnHold.by?.lastName
                }}</i>
              </div>
              <div>
                <i>{{
                  baseProject.putOnHold.date
                    | formatDate : '-' : 'dd/MM/yyyy HH:mm'
                }}</i>
              </div>
            </div>
          </div>
          <div class="more-upper-space less-mat-form-field-bottom-padding">
            <textarea-input
              [subtitle]="'Opvolging van deze job (datum en naam)'"
              [placeholder]="''"
              [initContent]="baseProject.onHoldHandling"
              [sensitive]="true"
              (answer)="onHoldHandlingChanged($event)"
            >
            </textarea-input>
            <div class="registered-action-display-container">
              <div>
                <mat-checkbox
                  [(ngModel)]="onHoldCheckboxModel"
                  (ngModelChange)="onHoldCheckboxModelChanged()"
                  ><i>Afgehandeld</i></mat-checkbox
                >
              </div>
              <div class="align-with-registration-checkbox">
                <i>{{
                  baseProject.onHoldHandled?.by?.firstName
                    | personName : baseProject.onHoldHandled?.by?.lastName
                }}</i>
              </div>
              <div class="align-with-registration-checkbox">
                <i>{{
                  baseProject.onHoldHandled?.date
                    | formatDate : '' : 'dd/MM/yyyy HH:mm'
                }}</i>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </ng-container>
  <div class="summary-card-container summary-card-top-margin">
    <div class="summary-card-header">Ontwerp</div>
    <mat-card class="top-card summary-card mat-elevation-z0 black-border-color">
      <div class="small-upper-space d-flex">
        <div class="configuration-container">
          <div class="strong f-s-larger">
            {{
              ipBoard.needsDesign
                ? 'Inpress maakt het ontwerp aan'
                : 'De klant levert het ontwerp aan'
            }}
          </div>
          <ul class="inpress-ul">
            <li>
              <span>Titel{{ doTitleSidesDiffer ? ' links' : '' }}: </span>
              <span class="strong">{{
                ipBoard.boardPart.sign?.title
                  | displayIPBoardAssociation
                    : ipBoard.boardPart.titleAdjustment?.title
                    : ipBoard.boardPart.otherTitle
                    : 'Geen titel gekozen'
              }}</span>
            </li>
            <li *ngIf="doTitleSidesDiffer">
              <span>Titel rechts: </span>
              <span class="strong">{{
                ipBoard.boardPart.sign?.title
                  | displayIPBoardAssociation
                    : ipBoard.boardPart.otherTitleAdjustment?.title
                    : ipBoard.boardPart.otherSideOtherTitle
                    : 'Geen titel gekozen'
              }}</span>
            </li>
            <ng-container
              *ngIf="!project.collaborative; else boardPartPhoneNumbers"
            >
              <li>
                <span
                  >Telnr{{ doPhoneNumberSidesDiffer ? ' links' : '' }}:
                </span>
                <span class="strong">{{
                  ipBoard.boardPart.sign?.phoneNumber
                    | displayIPBoardAssociation
                      : ipBoard.boardPart.phoneNumberAdjustment?.phoneNumber
                      : ipBoard.boardPart.otherPhoneNumber
                      : 'Geen telefoonnummer gekozen'
                }}</span>
              </li>
              <li *ngIf="doPhoneNumberSidesDiffer">
                <span>Telnr rechts: </span>
                <span class="strong">{{
                  ipBoard.boardPart.sign?.phoneNumber
                    | displayIPBoardAssociation
                      : ipBoard.boardPart.otherPhoneNumberAdjustment
                          ?.phoneNumber
                      : ipBoard.boardPart.otherSideOtherPhoneNumber
                      : 'Geen telefoonnummer gekozen'
                }}</span>
              </li>
            </ng-container>
            <ng-template #boardPartPhoneNumbers>
              <ng-container *ngIf="ipBoard.boardPart.phoneNumbers?.length > 0">
                <li *ngFor="let phoneNumber of ipBoard.boardPart.phoneNumbers">
                  <span>Telnr: </span>
                  <span class="strong"
                    >{{
                      phoneNumber.phoneNumber?.length > 0
                        ? phoneNumber.phoneNumber
                        : '{}'
                    }}
                    ({{ phoneNumber.company.regularName }})</span
                  >
                </li>
              </ng-container>
            </ng-template>
            <li *ngIf="ipBoard.boardPart.customText?.length > 0">
              <span class="preserve-line-break display-contents">
                <span
                  >Tekst{{
                    ipBoard.boardPart.otherCustomText?.length > 0
                      ? ' links'
                      : ''
                  }}:
                </span>
                <span class="strong inline-flex">{{
                  ipBoard.boardPart.customText
                }}</span>
              </span>
            </li>
            <li *ngIf="ipBoard.boardPart.otherCustomText?.length > 0">
              <span class="preserve-line-break display-contents">
                <span>Tekst rechts: </span>
                <span class="strong inline-flex">{{
                  ipBoard.boardPart.otherCustomText
                }}</span>
              </span>
            </li>
          </ul>

          <div
            *ngIf="
              ipBoard.boardPart.sticker != null ||
              ipBoard.boardPart.otherSticker?.length > 0
            "
            class="strong upper-space"
          >
            Ineens met sticker op bord:
            <span class="secondary-color">{{
              ipBoard.boardPart.sticker != null
                ? ipBoard.boardPart.sticker.text
                : ipBoard.boardPart.otherSticker
            }}</span>
          </div>

          <div
            *ngIf="ipBoard.generalExtraInfo?.length > 0"
            class="strong upper-space"
          >
            <div>
              <span class="preserve-line-break display-contents">
                <span class="inline-flex">{{ ipBoard.generalExtraInfo }}</span>
              </span>
            </div>
          </div>

          <div *ngIf="ipBoard.extraBoard != null" class="upper-space">
            <div>
              <span class="preserve-line-break display-contents">
                <span class="strong"
                  >Tekst {{ ipBoard.extraBoard.label | lowercase }}:
                </span>
                <span class="inline-flex">{{ ipBoard.extraBoardText }}</span>
              </span>
            </div>
            <div>
              <span class="preserve-line-break display-contents">
                <span class="strong"
                  >Gewenste kleuren {{ ipBoard.extraBoard.label | lowercase }}:
                </span>
                <span class="inline-flex">{{ ipBoard.extraBoardColor }}</span>
              </span>
            </div>
          </div>

          <div *ngIf="ipBoard.immoscoopLogo" class="upper-space d-flex">
            <img src="/assets/immoscoop_banner.png" class="immoscoop-logo" />
            <div class="immoscoop-text-container">
              <div class="immoscoop-text">Het Immoscoop logo toevoegen</div>
            </div>
          </div>

          <div *ngIf="ipBoard.spotto" class="upper-space d-flex">
            <img src="/assets/spotto_banner.png" class="spotto-logo" />
            <div class="spotto-text-container">
              <div class="spotto-text">Het Spotto logo toevoegen</div>
            </div>
          </div>
        </div>
        <div class="example-container design-preview-padding">
          <ip-board-design-preview
            *ngIf="
              ipBoard.boardPart.otherIPBoardPartType?.ordinal !==
              IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
            "
            [ipBoard]="ipBoard"
            [project]="project"
            [showCustomSignExample]="true"
          ></ip-board-design-preview>
          <div class="design-images">
            <ng-container *ngFor="let asset of ipBoard.productAssets">
              <div
                *ngIf="
                  !asset.archived &&
                  (asset.formSection === 'externalDesign' ||
                    asset.formSection === 'extraDesign') &&
                  isImage(asset.asset)
                "
              >
                <a
                  class="click-link"
                  href="/api/assets/{{ asset.asset.uuid }}"
                  data-lightbox="design-images"
                >
                  <img
                    class="design-image"
                    src="/api/assets/{{ asset.asset.uuid }}"
                  />
                </a>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <ng-container *ngIf="!client && canShowAdminSections && showDesignSection">
    <div class="admin-section-header">
      <div
        [class.collapsed]="designSectionCollapsed"
        class="d-flex"
        (click)="designSectionCollapsed = !designSectionCollapsed"
      >
        <div>Ontwerp</div>
        <div class="admin-section-arrow">
          <div>
            <button mat-icon-button>
              <mat-icon class="admin-section-arrow-icon"
                >arrow_drop_up</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
    </div>
    <div [collapse]="designSectionCollapsed" [isAnimated]="!safari">
      <div class="summary-card-container summary-card-top-margin">
        <div class="summary-card-header">Ontwerp</div>
        <mat-card
          class="top-card summary-card mat-elevation-z0 black-border-color"
        >
          <ip-board-extra-design
            [project]="project"
            [baseProject]="baseProject"
            [ipBoard]="ipBoard"
            (save)="save.emit()"
          ></ip-board-extra-design>
        </mat-card>
      </div>
    </div>
  </ng-container>
</ng-template>
